module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "point"
    }
  }, [_c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendAnswer()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.index + 1) + ".")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.point.question.text)
    }
  })]), _vm._v(" "), (_vm.point.question.media && _vm.point.question.media.length) ? _c('div', [(!_vm.mediaLoaded) ? _c('div', {
    staticClass: "modal-body text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('common.loading_images')) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.point.question.media), function(medium) {
    return _c('div', {
      key: medium._id,
      staticClass: "modal-body"
    }, [(!medium.error) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "id": 'medium-' + medium._id,
        "src": medium.optimized || medium.url
      }
    }) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.questionType !== 'none') ? _c('div', {
    class: 'modal-body question-' + _vm.questionType
  }, [(_vm.questionType === 'single' || _vm.questionType === 'multiple') ? _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.point.question.answers), function(option, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      class: {
        'text-success': _vm.answered && option.correct, 'text-danger': _vm.answered && !option.correct
      },
      attrs: {
        "colspan": (_vm.questionType === 'multiple' || _vm.answer === index) ? 1 : 2
      }
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [(_vm.questionType === 'single') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answer),
        expression: "answer"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "radio",
        "disabled": _vm.answered || _vm.loading
      },
      domProps: {
        "value": index,
        "checked": _vm._q(_vm.answer, index)
      },
      on: {
        "change": [function($event) {
          _vm.answer = index
        }, _vm.updateSingleTypeAnswer]
      }
    }) : _vm._e(), _vm._v(" "), (_vm.questionType === 'multiple') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answer),
        expression: "answer"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "disabled": _vm.answered || _vm.loading
      },
      domProps: {
        "value": index,
        "checked": Array.isArray(_vm.answer) ? _vm._i(_vm.answer, index) > -1 : (_vm.answer)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.answer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = index,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.answer = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.answer = $$c
          }
        }, _vm.updateMultipleTypeAnswer]
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "form-check-label-text"
    }, [_vm._v(_vm._s(option.text))])])]), _vm._v(" "), (_vm.answered && _vm.questionType === 'single' && _vm.answer === index) ? _c('td', {
      staticClass: "answer-validity"
    }, [(option.correct) ? _c('span', {
      staticClass: "pull-right text-success"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e(), _vm._v(" "), (!option.correct) ? _c('span', {
      staticClass: "pull-right text-danger"
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.answered && _vm.questionType === 'multiple') ? _c('td', {
      staticClass: "answer-validity"
    }, [((_vm.answer.indexOf(index) !== -1) === option.correct) ? _c('span', {
      staticClass: "pull-right text-success"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e(), _vm._v(" "), ((_vm.answer.indexOf(index) !== -1) !== option.correct) ? _c('span', {
      staticClass: "pull-right text-danger"
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e()]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.questionType === 'text' || _vm.questionType === 'number') ? _c('div', [(!_vm.answered && _vm.questionType === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.answered && _vm.questionType === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answered) ? _c('div', [(_vm.answered.correct) ? _c('p', {
    staticClass: "text-success"
  }, [_vm._v("\n                                    " + _vm._s(_vm.answer) + "\n                                    "), _vm._m(0, false, false)]) : _vm._e(), _vm._v(" "), (!_vm.answered.correct) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n                                    " + _vm._s(_vm.answer) + "\n                                "), _vm._m(1, false, false)]) : _vm._e(), _vm._v(" "), (!_vm.answered.correct) ? _c('p', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('point.correct_answer_is')))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.point.question.answers[0].text))])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.questionType === 'photo' || _vm.questionType === 'video') ? _c('div', [(_vm.questionType === 'video') ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('point.video_not_supported')) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.capturedMedia && !_vm.answered) ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "id": "media-preview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answered) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('point.answered_feedback')) + "\n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.capturedMedia && !_vm.answered) ? _c('div', [_c('input', {
    staticClass: "file-input",
    attrs: {
      "id": "image-input",
      "type": "file",
      "accept": "image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.captureMedia($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "image-input"
    }
  }, [_c('span', {
    staticClass: "btn btn-link"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('point.take_photo')) + "\n                                    ")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.capturedMedia && !_vm.answered) ? _c('span', [_c('input', {
    staticClass: "file-input",
    attrs: {
      "id": "image-input-retake",
      "type": "file",
      "accept": "image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.captureMedia($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "image-input-retake"
    }
  }, [_c('span', {
    staticClass: "btn btn-secondary"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('point.take_new_photo')) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), (!_vm.answered && !_vm.continueWithoutAnswering) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.answerEmpty || _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t('point.send_answer')) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.answered && _vm.continueWithoutAnswering) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.continue')) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.answered) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePoint()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.close')) + "\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop fade in"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea1593f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/point.vue
// module id = 375
// module chunks = 0